const data = {
  id: 1,
  title: 'Listen and number',
  subTitle: 'Nghe và đánh số thứ tự nội dung xuất hiện trong bài',
  // audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/963330b6-5116-4ab3-88bd-ccf433b2ecb4.mp3',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/e68d3d92-57c3-4acf-beec-9371cb4485ed.mp3',
  question: '',
  answers: [
    { answer: '1', imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/SGK/badminton.png' },
    { answer: '2', imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/SGK/play%20paper%20plane.png' },
    { answer: '3', imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/SGK/fly%20a%20kite.png' },
  ],
};

export default data;
